import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";
import { trackEvent } from "../../../shared/lib/analytics";

// Registrar um plantão precisa atualizar Dashboard + Recebíveis + Calendário + KPIs +
// Vínculo detalhe simultaneamente — resolvido com invalidação por queryKey, sem
// callbacks de refetch espalhados pelas telas.
export function useCreatePlantaoMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.create,
    onSuccess: () => {
      trackEvent("plantao_registrado");
      invalidateShiftQueries(queryClient);
    },
  });
}
